export interface DateRangeValue {
  start: number | null;
  end: number | null;
}

export const isDateRangeType = (
  value: unknown
): value is DateRangeValue => {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'start' in value &&
      'end' in value
  );
};

